/**
 * @fileoverview Table skeleton for Needs Review listings.
 * @module features/sku-alias/components/NeedsReviewSkeleton
 */

import { ReactElement } from 'react'

import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeleton component replicating table rows during loading state.
 *
 * @component
 */
export function NeedsReviewSkeleton(): ReactElement {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className="grid grid-cols-[32px,1.5fr,1fr,1.2fr,1.2fr,1.5fr] items-center gap-4 rounded-3xl border border-border/15 bg-card px-6 py-4"
        >
          <Skeleton className="h-4 w-4 rounded-sm" />
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-9 w-32 rounded-full" />
        </div>
      ))}
    </div>
  )
}

export default NeedsReviewSkeleton
